import { observer } from "mobx-react";
import React, { useRef, useState, useEffect, useMemo } from "react";
import ArrowButton from "../ArrowButton";
import AToZ from "../AToZ";
import empty from "../../assets/images/svg/modalEmpty.svg";
import SearchButton from "../SearchButton/SearchButton";
import EmptyButton from "../SelectButton/EmptyButton";
import FilledButton from "../SelectButton/FilledButton";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import ReportsStore from "../../store/ReportsStore";
import { getCookie } from "../../utils/cookie";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import { getDecodedToken } from "../../utils/functions";

const ModalFamily = observer(
  ({
    selectedMemberForReports,
    setSelectedMemberForReports,
    onClose,
    showResetAndSubmit,
    searchBarWidth,
    isSort,
    setSort,
    unrealised,
    loader,
    handleWealth,
    open,
    aToZclassName = "",
    searchBtnClassName = "",
    onClickApply = () => {},
  }) => {
    const [search, setSearch] = useState("");
    const [selectedLocal, setSelectedLocal] = useState(
      UserStore.selectedClientId
    );
    const [isLoading, setIsLoading] = useState(false);

    const filteredMembers = UserStore.currentFamilyMembers?.filter((member) => {
      return member.full_name.toLowerCase().includes(search.toLowerCase());
    });

    const buttonsRef = useRef(null);
    const searchRef = useRef(null);
    const divRef = useRef(null);
    const familyRef = useRef(null);

    useEffect(() => {
      if (open) {
        setSelectedLocal(UserStore.selectedClientId);
      }
    }, [open]);

    const getDefaultImage = (name) => {
      return <div className="profileImageDefault2">{name[0]}</div>;
    };

    const resetClick = () => {
      setSelectedLocal("0");
      setSelectedMemberForReports("0");
    };

    const getClasses = (condition, index, length) => {
      return !condition ? "member_body" : "member_body members_order";
    };

    const handleClick = (id, isprimary, data) => {
      setSelectedLocal(id);
      UserStore.setSelectedMemberIsPrimary(isprimary);
      if (id === "0") {
        ReportsStore.updateReportsTodefault("check6");
        ReportsStore.updateCorporateFilterData(id);
        ReportsStore.updatePortfolioReportFilterData("All", "mod1");
      } else {
        ReportsStore.updatePortfolioReportFilterData(data, "mod2");
        ReportsStore.updateTransactionFilterData(data, "check");
        ReportsStore.updateCorporateFilterData(data);
      }
    };

    const handleSubmit = () => {
      onClickApply();
      if (loader) {
        window.scrollTo(0, 0);
        AuthStore.updateLoadingFullScreen(true);
      }
      if (selectedLocal === "0") {
        PerformanceStore.setFamOrClient({ name: "fam", id: "0" });
        UserStore.setClientOrFamily("fam");

        const user = UserStore.currentFamilyMembers?.find(
          (data) => String(data.user_id) === getCookie("selectedUsersId")
        );

        UserStore.setUserData(
          {
            ...user,
            allMembers: true,
            investmentHeldWith:
              getDecodedToken()?.user_type === "customer"
                ? UserStore.loggedInWithOthers
                : user.investmentHeldWith,
          },
          "0"
        );

        UserStore.setSelectedClientId("0");
      } else {
        UserStore.setClientOrFamily("client");
        PerformanceStore.setFamOrClient({
          name: "client",
          id: selectedLocal,
        });
        const memberData = UserStore.currentFamilyMembers?.find(
          (data) => data.user_id === selectedLocal
        );
        const { isheldaway } = memberData;

        UserStore.setUserData({
          ...memberData,
          investmentHeldWith:
            !isheldaway || getDecodedToken()?.user_type !== "customer"
              ? memberData.investmentHeldWith
              : UserStore.loggedInWithOthers,
          allMembers: false,
          memberSwitched: true,
        });

        UserStore.setSelectedClientId(selectedLocal);
      }
      handleWealth && handleWealth();
      onClose();
      setIsLoading(false);
    };

    const handleRef = (type) => {
      type === "hide"
        ? (searchRef.current.style.display = "none")
        : (searchRef.current.style.display = "flex");
    };

    const highlighter = (name) => {
      if (name.toLowerCase().includes(search.toLowerCase()) && search) {
        let regex = new RegExp(`(${search})`, "gi");
        const parts = name.split(regex);
        return parts.map((part, index) =>
          part.match(regex) ? <span className="highlight">{part}</span> : part
        );
      }
      return name;
    };

    const sortedArray = useMemo(() => {
      let sortedData = filteredMembers;
      if (sortedData && isSort === "asc") {
        sortedData = [...sortedData]?.sort((a, b) => {
          return a.full_name.localeCompare(b.full_name);
        });
      } else if (sortedData && isSort === "desc") {
        sortedData = [...sortedData]?.sort((a, b) => {
          return b.full_name.localeCompare(a.full_name);
        });
      }
      return sortedData;
    }, [filteredMembers, isSort]);

    useEffect(() => {
      if (ReportsStore.excelDownloadStatus === "pending") {
        document.getElementsByTagName("html")[0].style.overflow = "hidden";
      } else {
        document.getElementsByTagName("html")[0].style.overflow = "auto";
      }
    }, [ReportsStore.excelDownloadStatus]);

    return (
      <>
        {isLoading && (
          <img
            className=""
            style={{
              height: 40,
              width: 40,
              position: "absolute",
              top: "calc(50% - 40px)",
              left: "calc(50% - 40px)",
            }}
            src={loaderGIF}
            alt="loading..."
          />
        )}
        <div
          style={{ pointerEvents: isLoading ? "none" : "unset" }}
          className="family_modal"
        >
          <div ref={buttonsRef} className="modal_search">
            <div ref={searchRef} className="atozref">
              <div
                onClick={() => {
                  switch (isSort) {
                    case "asc":
                      setSort("desc");
                      break;
                    case "desc":
                      setSort("asc");
                      break;
                    default:
                      setSort("desc");
                      break;
                  }
                }}
                className="familiies_a_to_z"
              >
                <AToZ isSort={isSort} className={`${aToZclassName}`} />
              </div>
            </div>
            <div className="modal_search_ip">
              <SearchButton
                type={"search"}
                search={search}
                setSearch={(data) => setSearch(data)}
                width={searchBarWidth || "710px"}
                handleRef={(type) => handleRef(type)}
                className={searchBtnClassName}
              />
            </div>
          </div>

          {sortedArray?.length ? (
            <div ref={familyRef} className="family">
              <div className="all_members">
                {!unrealised && (
                  <div
                    style={{ cursor: "pointer" }}
                    className="member_title_all"
                    onClick={() => {
                      setSelectedLocal("0");
                      setSelectedMemberForReports
                        ? setSelectedMemberForReports("All")
                        : handleClick("0", true);
                    }}
                  >
                    <button
                      className="member_button"
                      onClick={() => {
                        if (handleWealth && selectedLocal === "0") {
                          handleSubmit();
                        } else {
                          setSelectedLocal("0");
                          setSelectedMemberForReports
                            ? setSelectedMemberForReports("All")
                            : handleClick("0", true);
                        }
                      }}
                      aria-label={"Select All Members"}
                    >
                      {selectedMemberForReports ? (
                        selectedMemberForReports === "All" ? (
                          <FilledButton />
                        ) : (
                          <EmptyButton />
                        )
                      ) : selectedLocal !== "0" ? (
                        <EmptyButton />
                      ) : (
                        <FilledButton />
                      )}
                    </button>{" "}
                    <span className="member_title">All Members </span>
                  </div>
                )}
                {sortedArray?.map((data, index, currArray) => {
                  return (
                    <div
                      style={{
                        cursor: "pointer",
                        // borderWidth:
                        //   index === sortedArray.length - 1 ? 0 : "auto",
                      }}
                      key={data?.user_id}
                      ref={divRef}
                      className={getClasses(
                        data.isprimary,
                        index,
                        currArray.length
                      )}
                      onClick={() => {
                        setSelectedLocal(data?.user_id);
                        setSelectedMemberForReports
                          ? setSelectedMemberForReports(data)
                          : handleClick(data.user_id, data.isprimary, data);
                      }}
                    >
                      <button
                        className="member_button"
                        onClick={() => {
                          if (handleWealth && data?.user_id === selectedLocal) {
                            handleSubmit();
                          } else {
                            setSelectedLocal(data?.user_id);
                            setSelectedMemberForReports
                              ? setSelectedMemberForReports(data)
                              : handleClick(data.user_id, data.isprimary, data);
                          }
                        }}
                        aria-label={`Select ${data.full_name}`}
                      >
                        {(selectedMemberForReports
                          ? selectedMemberForReports.user_id
                          : selectedLocal) !== data.user_id ? (
                          <EmptyButton />
                        ) : (
                          <FilledButton />
                        )}
                      </button>
                      <div>
                        {!data.profile_pic ||
                        !UserStore.currentFamilyMembersImages?.[
                          data.user_id
                        ] ? (
                          getDefaultImage(data.full_name)
                        ) : PerformanceStore.loaderClosingCheckForImage?.[
                            `${data?.user_id}2`
                          ] &&
                          PerformanceStore.loaderClosingCheckForImage?.[
                            `${data?.user_id}2`
                          ] === "pending" ? (
                          <>
                            <div className="skeleton" />
                            <div />
                          </>
                        ) : (
                          <img
                            className="member_profile"
                            src={
                              UserStore.currentFamilyMembersImages?.[
                                data.user_id
                              ]
                            }
                            alt=""
                          />
                        )}
                      </div>
                      <div className="member_name">
                        {highlighter(data.full_name)}
                      </div>
                      {data.isprimary && (
                        <span className="ismemberprimary">primary</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "1px solid",
                margin: "auto",
                width: "90%",
                padding: "60px",
                marginTop: "32px",
                justifyContent: "center",
                borderRadius: "20px",
                height: "300px",
                borderColor: "#DDE2EB",
                textAlign: "center",
              }}
            >
              <img
                style={{ width: "fit-content", marginBottom: "32px" }}
                src={empty}
                alt=""
              />
              <p
                style={{
                  marginBottom: "15px",
                  fontFamily: "Encode Sans",
                  fontWeight: "500",
                  fontSize: "18px",
                }}
              >
                Family Member not found
              </p>
              <p>The name “{search}” did not match any Family member</p>
            </div>
          )}

          {showResetAndSubmit !== false && !!sortedArray?.length && (
            <div className="modal_buttons">
              <button onClick={resetClick} className="family_reset">
                <span
                  style={{
                    cursor: "pointer",
                  }}
                  className="modal_reset"
                >
                  Reset
                </span>
              </button>

              <ArrowButton
                type={"next"}
                label={"Apply"}
                onClick={() => {
                  setIsLoading(true);
                  setTimeout(() => {
                    handleSubmit();
                  }, 10);
                }}
              />
            </div>
          )}
        </div>
      </>
    );
  }
);

export default ModalFamily;
